import { get } from "lodash-es";

export const getBindDataStringByKey = function (bindData, key, returnObject) {
  let findData = get(bindData, key);
  if (typeof findData == "undefined") {
    findData = null;
  } else if (typeof findData == "boolean" && !findData) {
    findData = null;
  }

  let res = "";
  if (findData !== null) {
    if (returnObject) {
      res = findData;
    } else if (typeof findData == "number") {
      res = findData;
    } else {
      res = findData.toString();
    }
  }
  return res;
};
const getVariableValue = (variable) => {
  // [ 'name' ]、[ 'age' ]、[ 'job', 'name' ]
  variable = variable.split(".");
  let variableValue = obj;
  while (variable.length) {
    variableValue = variableValue[variable.shift().trim()];
  }
  return variableValue;
};

export function renderStrTemplate(str, obj) {
  const template = str;
  const variableRegex = /\$\{([^${}]+)\}/g;

  const renderStr = template.replace(variableRegex, ($0, variable) => {
    return getVariableValue(variable);
  });
  return renderStr;
}
